import $ from 'jquery';
import { colors } from '../colors';
import { pie } from '../options';

class IncorrectCodes2 {
  constructor() {
  }

  static Chart() {
    let ctx = $('#charts__incorrect-codes_2');
    let check = $('canvas').is('#charts__incorrect-codes_2');
    let project_id = $('[data-project-id]').data('project-id');

    let first_week = parseUrl('start_week')
    let end_week = parseUrl('end_week')
    let days_from = parseUrl('days_from')
    let days_to = parseUrl('days_to')
    let period_filter_type = parseUrl('period_filter_type')
    let periodParams = '&period_filter_type=' + period_filter_type +
                       '&start_week=' + first_week + '&end_week=' + end_week +
                       '&days_from=' + days_from + '&days_to=' + days_to

    if(check) {
      $.ajax({
        url: '/api/v1/statistics/codes_invalid_reasons?project_id=' + project_id + periodParams,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          initChart(response)
        }
      });

      let initChart = function(response){
        if (response.data[0] == 0 && response.data[1] == 0){
          $(ctx).parent().html('<div class="not_enough_data"><b>Для отображения недостаточно данных</b></div>')
          return;
        }

        let data = {
          labels: response.labels,

          datasets: [
            {
              data: response.data,
              backgroundColor: [ colors.red[300], colors.orange[300], colors.green[300] ],
              hoverBackgroundColor: [ colors.red[500], colors.orange[500], colors.green[500] ],
              borderColor: [ colors.red[500], colors.orange[500], colors.green[500] ],
              hoverBorderColor: [ colors.red[500], colors.orange[500], colors.green[500] ],
              fill: true,
              datalabels: {
                color: [colors.white.primary, colors.black.primary, colors.white.primary]
              }
            }
          ]
        };

        var total_sum = response.data.reduce((a, b) => a + b, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        var options = Object.assign({}, pie, {title: {display: true, text: ('Всего ' + total_sum), position: 'bottom'}});
        options['legend']['align'] = 'start'
        options['legendCallback'] =   function(chart) {
          let containerClasses = [
            '#charts__incorrect-codes_2_container .js-valid-stats',
            '#charts__incorrect-codes_2_container .js-invalid-stats'
          ];
          let currentDataset = chart.data.datasets[0];

          let dataSum = currentDataset.data.reduce((a, b) => a + b, 0);
          let parentContainer = ctx.parents('.card-body');

          for (let i = 0; i < currentDataset.data.length; i++) {
            let containerClass = containerClasses[i];
            let iconColor = currentDataset.backgroundColor[i];

            let value = currentDataset.data[i];
            let percentage = (value * 100 / dataSum).toFixed(2);
            let valueString = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

            $(parentContainer).find(containerClass).find('.circle-media-body .count').text(valueString);
            $(parentContainer).find(containerClass).find('.circle-media-body .percentage').text('(' + percentage + '%)');
            $(parentContainer).find(containerClass).find('.circle-media-icon').css('color', iconColor);
          }
        }

        let codesStatsChart2 = new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: data.labels,
            datasets: data.datasets
          },
          options: options
        });
        codesStatsChart2.generateLegend();
      }
    }
  }

  static onInit() {
    IncorrectCodes2.Chart();
  }
}

export default IncorrectCodes2;
